var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferAFriend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Planned for today"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.9103 50.2158C33.068 52.29 33.6315 54.3173 34.573 56.1813C35.9124 58.8612 37.9714 61.1153 40.5195 62.6911C43.0676 64.2669 46.0041 65.1021 49.0001 65.1033C51.5056 65.1098 53.9772 64.5244 56.2136 63.3948L67.0339 67.0016L63.4272 56.1813C64.5568 53.9448 65.1422 51.4732 65.1356 48.9677C65.1345 45.9717 64.2992 43.0352 62.7234 40.4871C61.1476 37.939 58.8935 35.88 56.2136 34.5406C54.7421 33.7973 53.1687 33.2897 51.5509 33.0312",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1212",
    d: "M40.6303 50.6914C40.6303 51.8132 40.8612 52.924 41.3101 53.9604C41.7589 54.9968 42.4167 55.9385 43.246 56.7318C44.0753 57.525 45.0598 58.1542 46.1433 58.5835C47.2268 59.0128 48.3881 59.2338 49.5609 59.2338C50.7337 59.2338 51.895 59.0128 52.9785 58.5835C54.062 58.1542 55.0466 57.525 55.8758 56.7318C56.7051 55.9385 57.363 54.9968 57.8118 53.9604C58.2606 52.924 58.4916 51.8132 58.4916 50.6914L40.6303 50.6914Z",
    fill: "#FCA66C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M49.949 26.1865C49.958 29.6316 49.1531 33.03 47.5999 36.1051C45.7582 39.79 42.927 42.8894 39.4234 45.0561C35.9198 47.2228 31.8821 48.3713 27.7626 48.3729C24.3176 48.3819 20.9191 47.577 17.844 46.0237L2.96606 50.9831L7.92538 36.1051C6.37215 33.03 5.56725 29.6316 5.57623 26.1865C5.57782 22.067 6.7263 18.0293 8.89302 14.5257C11.0597 11.0221 14.1591 8.19087 17.844 6.34922C20.9191 4.796 24.3176 3.99109 27.7626 4.00007H29.0677C34.5082 4.30022 39.6468 6.59657 43.4997 10.4494C47.3525 14.3023 49.6489 19.4409 49.949 24.8814V26.1865Z",
    fill: "#FCA66C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.57623 26.1865C5.56725 29.6316 6.37215 33.03 7.92538 36.1051L2.96606 50.983L17.844 46.0237C20.9191 47.577 24.3176 48.3819 27.7626 48.3729C31.8821 48.3713 35.9198 47.2228 39.4234 45.0561C42.927 42.8894 45.7582 39.79 47.5999 36.1051C49.1531 33.03 49.958 29.6316 49.949 26.1865V24.8814C49.6489 19.4409 47.3525 14.3023 43.4997 10.4494C39.6468 6.59657 34.5082 4.30022 29.0677 4.00007H27.7626",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1212_2",
    d: "M39.7711 28.5586C39.7711 28.2825 39.5473 28.0586 39.2711 28.0586L14.7118 28.0586C14.4356 28.0586 14.2118 28.2825 14.2118 28.5586C14.2118 30.1699 14.5436 31.7649 15.1877 33.2522C15.8318 34.7395 16.7751 36.0894 17.9628 37.2254C19.1504 38.3614 20.5592 39.2614 22.1081 39.8751C23.6569 40.4888 25.3162 40.8044 26.9915 40.8044C28.6667 40.8044 30.326 40.4888 31.8748 39.8751C33.4237 39.2614 34.8325 38.3614 36.0201 37.2254C37.2078 36.0894 38.1512 34.7395 38.7952 33.2522C39.4393 31.7649 39.7711 30.1699 39.7711 28.5586Z",
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferAFriend);
export default __webpack_public_path__ + "static/media/refer_a_friend.fd9d20f637cdd4dc3ebe1409baf468a8.svg";
export { ForwardRef as ReactComponent };